import { defineComponent as _defineComponent } from 'vue'
import { t } from '@/plugins/i18n';
import { prepareAvailableFloorsLevels } from '../service/helpers';
import { useFloorsStore, useLocationsStore, useAppStore, useMessagingStore, useCamerasStore } from '@/stores';
import { computed, reactive } from 'vue';
import api from '@eencloud/eewc-components/src/service/api';
import router from "@/service/router";
import TooltippedText from "@eencloud/eewc-components/src/components/tooltip/TooltippedText/TooltippedText.vue";

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsSidebar',
  props: {
    open: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const floorStore = useFloorsStore();
const locationsStore = useLocationsStore();
const appStore = useAppStore();
const messagingStore = useMessagingStore();
const camerasStore = useCamerasStore();





// computed variables
const showCameraNames = computed( {
  get: () => appStore.showCameraNames,
  set: (value) => {
    appStore.$patch({ showCameraNames: value })
    localStorage.setItem('showCameraNames', String(value))
  }
});


const showCameraFOV = computed( {
  get: () => appStore.showCameraFOV,
  set: (value) => {
    appStore.$patch({ showCameraFOV: value })
    localStorage.setItem('showCameraFOV', String(value))
  }
});

const availableFloors = computed(() => {
  const usedFloors = floorStore.floors || [];
  return prepareAvailableFloorsLevels(usedFloors);
})

// Select buttons
const currentLocation = computed(() => {
  return {
    text: locationsStore?.currentLocation?.name,
    value: locationsStore?.currentLocation?.id,
    ...locationsStore?.currentLocation
  }
});

const currentFloor = computed(() => {
  return {
    text: floorStore?.currentFloor?.name,
    value: floorStore?.currentFloor?.id,
    ...floorStore?.currentFloor
  }
});

// reactive data
const newFloor = reactive({
  floorLevel: currentFloor.value.floorLevel,
  newFloorName: currentFloor.value.name,
  defaultName: currentFloor.value.name
});


// methods
const selectFloor = (floor: {text: string, value: number}) => {
  newFloor.floorLevel = floor.value;
  newFloor.newFloorName = floor.text;
  newFloor.defaultName = floor.text;
}

const savedChangesNotification = () => {
  messagingStore.addNotification(
    {
      iconColor: 'positive',
      icon: '$icon_check_zero',
      title: t('Changes saved successfully'),
      body: 'All changes you made have applied to this floor plan.',
    }
  );
  router.push({'path': `/location/${currentLocation.value.id}/floor_plan/${currentFloor.value.id}`});
  appStore.loading = false;
}

const saveSettings = async () => {
  const camerasToUpdate = floorStore.currentFloorCameras;
  appStore.loading = true;
  emit("close");
  if (!currentLocation.value.id || !currentFloor.value.id) {
    appStore.loading = false;
    return;
  }
  try {
    await api.updateFloor(currentLocation.value.id, currentFloor.value.id, {
      name: newFloor.newFloorName || newFloor.defaultName
    })
    if (currentFloor.value.floorLevel !== newFloor.floorLevel) {
      await camerasStore.performCamerasBulkUpdate(camerasToUpdate, { floor: null });
    }
    const current_floor = floorStore.getFloorById(currentFloor.value.id);
    await floorStore.getAllFloorsByLocationId();
    await floorStore.setCurrentFloor(current_floor);
    appStore.loading = false;
    savedChangesNotification();
  } catch {
    messagingStore.addNotification(
      {
        iconColor: 'negative',
        icon: '$icon_attention',
        title: t('Something went wrong'),
        body: t('Something went wrong. Please try again later'),
      }
    );
    appStore.loading = false;
  }
}

return { __sfc: true,floorStore, locationsStore, appStore, messagingStore, camerasStore, emit, showCameraNames, showCameraFOV, availableFloors, currentLocation, currentFloor, newFloor, selectFloor, savedChangesNotification, saveSettings, t, TooltippedText }
}

})